module.exports = __webpack_public_path__ + "static/media/zola-theme-icons.802e9202.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/zola-theme-icons.eot?24613844
// module id = 1659
// module chunks = 49